/**
 * @func 通用配置构造
 * @author zhangfs by Atom
 * @param 2019/01/30 12:10
 */

const HttpError = {
  400: '请求错误，请联系IT报事',
  401: '当前用户未授权，请您重新登录',
  403: '您暂无权限查看该页面',
  404: '未找到该页面',
  408: '请求超时，请您稍后重试',
  500: '服务正忙，请您稍后再试',
  501: '服务正忙，请您稍后再试',
  502: '服务正忙，请您稍后再试',
  503: '服务正忙，请您稍后再试',
  504: '服务正忙，请您稍后再试',
  505: '服务正忙，请您稍后再试'
}

const Notify = {
  error: {
    title: '错误',
    message: '请求失败，请联系管理员',
    type: 'error'
  },
  warn: {
    title: '警告',
    message: '请检查您的操作是否合理',
    type: 'warning'
  },
  succes: {
    title: '成功',
    message: '操作成功',
    type: 'success'
  }
}

export { HttpError, Notify }



// WEBPACK FOOTER //
// ./src/config/index.js